import React, { useRef } from "react";

import "./style.scss";
import { connect } from "react-redux";
import { compose, withState, withHandlers } from "recompose";
import AttributeList from "./AttributeList";
import { Grid, IconButton } from "@material-ui/core";
import TopContent from "./TopContent";
import BottomContent from "./BottomContent";
import Map from "./Map";
import {
  KeyboardArrowLeft,
  KeyboardArrowRight,
  KeyboardArrowDown,
  KeyboardArrowUp,
} from "@material-ui/icons";
import { ToggleShowHideTopContent, ToggleShowHideBottomContent } from "../../services/actions/GisAction";
import Loading from "../../shared/components/Loading";
import { EnableV3 } from "../../env.config";
import { Button, ButtonGroup } from "@material-ui/core";

const Gis = ({
  loading,
  showTopContent,
  showAttributeList,
  ToggleTopContent,
  dataDetailSelected,
  showSurveyedDetail,
  closeSurveyedDetail,
  shouldShowDetail,
  showBottomContent,
  ToggleBottomContent,
  isAdmin
}) => {
  const mapEl = useRef(null);
  return (
    <Grid container>
      {loading && (
        <div className="loading-container">
          <Loading />
        </div>
      )}
      <div
        className="map-search-section"
        style={{
          position: "absolute",
          zIndex: "1001",
          backgroundColor: "white",
          display: showTopContent ? "block" : "none",
        }}
      >
        {
          //V3機能無効時
        }
        {!EnableV3 && (
          <TopContent
            mapEl={mapEl}
            closeSurveyedDetail={closeSurveyedDetail}
          />
        )}
        {
          //V3機能有効時
        }
        {EnableV3 && (
          <TopContent
            mapEl={mapEl}
            closeSurveyedDetail={closeSurveyedDetail}
          />
        )}
        <ToggleTopButton
          showTopContent={showTopContent}
          toggleTopContent={ToggleTopContent}
          isAdmin={isAdmin}
        />
      </div>

      {!showTopContent ? (
        <ToggleTopButton
          showTopContent={showTopContent}
          toggleTopContent={ToggleTopContent}
          isAdmin={isAdmin}
        />
      ) : (
        <></>
      )}

      <Grid item md={12} xs={12}>
        {showAttributeList && (
          <AttributeList showSurveyedDetail={showSurveyedDetail} />
        )}
        <Map
          mapEl={mapEl}
          dataDetailSelected={dataDetailSelected}
          showSurveyedDetail={showSurveyedDetail}
          closeSurveyedDetail={closeSurveyedDetail}
          shouldShowDetail={shouldShowDetail}
        />
      </Grid>
    
      <div
        className="data-table-section"
        style={{
          position: "absolute",
          zIndex: "1001",
          backgroundColor: "white",
          display: showBottomContent ? "block" : "none",
        }}
        >
          {
            //V3機能無効時
          }
          {!EnableV3 && (
            <BottomContent
              
            />
          )}
          {
            //V3機能有効時
          }
          {EnableV3 && (
              <BottomContent
                
              />
          )}
          <ToggleBottomButton
            showBottomContent={showBottomContent}
            toggleBottomContent={ToggleBottomContent}
          />
      </div>

      <ButtonGroup size="small" className="off-focus" style={{ position: 'absolute', top: '270px', right: '10px', display: 'block' }}>
        <Button
          className="off-focus"
          onClick={() => {
            // きれいな方法ではないが、子コンポーネントの非表示となっているリセットボタンをクリックさせる
            const targetBtn = document.getElementById('bottomFilterResetBtn');
            if (targetBtn != null) {
              targetBtn.click();
            }
          }}>
          RESET
        </Button>
      </ButtonGroup>

      {!showBottomContent ? (
        <ToggleBottomButton
          showBottomContent={showBottomContent}
          toggleBottomContent={ToggleBottomContent}
        />
      ) : (
        <></>
      )}
    </Grid>
  );
};

const ToggleTopButton = ({ showTopContent, toggleTopContent, isAdmin }) => (
  <IconButton
    className={`${isAdmin ? 'toggle-show-hide-top-button' : 'toggle-show-hide-top-button2'} ${!showTopContent && "hide"}`}
    onClick={() => toggleTopContent()}
  >
    {showTopContent ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
  </IconButton>
);

const ToggleBottomButton = ({ showBottomContent, toggleBottomContent }) => (
  <IconButton
    className={`toggle-show-hide-bottom-button ${!showBottomContent && "hide"}`}
    onClick={() => toggleBottomContent()}
  >
    {showBottomContent ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
  </IconButton>
);

export default compose(
  withState("dataDetailSelected", "setDataDetailSelected", null), // 属性検索結果
  withState("shouldShowDetail", "setShouldShowDetail", false),
  connect(
    (state) => ({
      showAttributeList: state.road.showAttributeList,
      showTopContent: state.gis.showTopContent,
      showBottomContent: state.gis.showBottomContent,
      loading: state.road.loading,
      surveyedMapType: state.gis.surveyedMapType,
      tableData: state.gis.tableData,
      isAdmin: state.auth.isAdmin,
    }),
    (dispatch) => ({
      ToggleTopContent: () => dispatch(ToggleShowHideTopContent()),
      ToggleBottomContent: () => dispatch(ToggleShowHideBottomContent()),
    })
  ),
  withHandlers({
    // 属性検索 -> ポップアップ
    // setDataDetailSelected : 属性詳細の設定関数
    // setShouldShowDetail : ポップアップの表示detail
    showSurveyedDetail: ({ setDataDetailSelected, setShouldShowDetail }) => {
      // startPos: クリック位置(要否不明)
      // startDate: 日付(APIのurlで必要)
      // kp: 調査位置ID
      // transitionObject
      return (aPos, aDate, aKp, aTransitionObject) => {
        setShouldShowDetail(true);
        setDataDetailSelected({
          startPosition: aPos,
          startDate: aDate,
          kp: aKp,
          transitionObject: aTransitionObject,
        });
      };
    },
    closeSurveyedDetail: ({ setShouldShowDetail, setDataDetailSelected }) => {
      return (clearData) => {
        setShouldShowDetail(false);
        if (clearData) {
          setDataDetailSelected(null);
        }
      };
    },
  })
)(Gis);
